// src/components/reports/StatusBadge.jsx
import React from 'react';
import { 
  Clock, 
  AlertTriangle, 
  CheckCircle, 
  X 
} from 'lucide-react';

const StatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'pending':
        return {
          icon: Clock,
          bg: 'bg-yellow-100',
          text: 'text-yellow-800',
          label: 'Pending'
        };
      case 'in_review':
        return {
          icon: AlertTriangle,
          bg: 'bg-blue-100',
          text: 'text-blue-800',
          label: 'In Review'
        };
      case 'resolved':
        return {
          icon: CheckCircle,
          bg: 'bg-green-100',
          text: 'text-green-800',
          label: 'Resolved'
        };
      case 'dismissed':
        return {
          icon: X,
          bg: 'bg-gray-100',
          text: 'text-gray-800',
          label: 'Dismissed'
        };
      default:
        return {
          icon: Clock,
          bg: 'bg-gray-100',
          text: 'text-gray-800',
          label: status
        };
    }
  };

  const config = getStatusConfig(status);
  const Icon = config.icon;

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
      <Icon className="mr-1 h-3 w-3" />
      {config.label}
    </span>
  );
};

export default StatusBadge;